<template>
  <div class="entity-page-component">
    <div class="tool-bar">
      <div>
        <v-btn flat icon light v-on:click="goBack" active-class>
          <v-icon>arrow_back</v-icon>
        </v-btn>
        <span class="title">{{ $t("message.Back") }}</span>
      </div>
      <div>
        <v-btn flat icon light v-on:click="save">
          <v-icon>done</v-icon>
        </v-btn>
      </div>
    </div>
    <div class="entity-page" :style="{ 'min-height': computedPageHeight}">
      <div class="header">
        <v-icon large>business</v-icon>
        <div class="fullname">{{ cardIdFormat }} {{ entityName }}</div>
        <v-tooltip left class="card-progress">
          <v-progress-circular
            slot="activator"
            :rotate="90"
            :size="66"
            :width="8"
            :value="cardProgress"
            color="secondary"
          >{{cardProgress}}%</v-progress-circular>
          <span>{{ $t('message.CardProgress') }}</span>
        </v-tooltip>
      </div>
      <v-tabs slider-color="secondary" class="app-tabs">
        <v-tab ripple>{{ $t('message.General') }}</v-tab>
        <v-tab ripple>{{ $t('message.Time') }}</v-tab>
        <v-tab-item>
          <div class="content">
            <div class="content-left">
              <div style="text-align: right">
                <v-menu
                  :close-on-content-click="false"
                  :nudge-width="200"
                  offset-y
                  v-model="timeMenu"
                >
                  <v-tooltip left slot="activator">
                    <v-btn color="lsecondary" flat icon slot="activator">
                      <v-icon>add_circle</v-icon>
                    </v-btn>
                    <span>{{ $t('message.AddTime') }}</span>
                  </v-tooltip>
                  <v-card>
                    <div class="time-form">
                      <div>
                        <v-text-field
                          v-model="timeSpent"
                          :label="$t('message.Spent')"
                          v-on:focus="$event.target.select()"
                          style="width: 80px;"
                        ></v-text-field>
                        <v-text-field
                          v-model="timeRemaining"
                          :label="$t('message.Remaining')"
                          v-on:focus="$event.target.select()"
                          style="width: 80px;"
                        ></v-text-field>
                      </div>
                      <div>
                        <v-textarea v-model="timeComment" :label="$t('message.Comment')" rows="3"></v-textarea>
                      </div>
                      <div>
                        <v-menu
                          ref="menuTimeDate"
                          :close-on-content-click="false"
                          v-model="menuTimeDate"
                          :nudge-right="40"
                          lazy
                          transition="scale-transition"
                          offset-y
                          full-width
                          max-width="290px"
                          min-width="290px"
                        >
                          <v-text-field
                            slot="activator"
                            v-model="timeDate"
                            :label="$t('message.Date')"
                            prepend-icon="event"
                            readonly
                          ></v-text-field>
                          <v-date-picker
                            v-model="timeDate"
                            no-title
                            scrollable
                            @input="menuTimeDate = false"
                          ></v-date-picker>
                        </v-menu>
                      </div>
                    </div>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" flat v-on:click="saveTime">Save</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-menu>
              </div>
              <v-text-field v-model="entityName" :label="$t('message.Name')"></v-text-field>
              <label>{{ $t('message.Description')}}</label>
              <textarea v-model="entityDescription"></textarea>
            </div>
            <div class="sidebar-right">
              <div class="user-assignaments">
                <div class="ua-header">
                  <span class="ua-title">{{$t('message.Assignaments')}}</span>
                  <v-btn flat icon light small color="lsecondary" v-on:click="toggleAddNewMember">
                    <v-icon :class="{ hidden: !addNewMemberHidden}">add_circle</v-icon>
                    <v-icon :class="{ hidden: addNewMemberHidden}">remove_circle</v-icon>
                  </v-btn>
                </div>
                <div v-for="resource in assignMembers" v-bind:key="resource.cardMembersId">
                  <v-btn flat icon dark>
                    <img
                      v-bind:src="resource.image"
                      alt="owner image"
                      style="width:28px; border-radius: 50%;"
                    />
                  </v-btn>
                  <span>{{ resource.name }}</span>
                  <v-btn
                    flat
                    icon
                    light
                    small
                    color="darkgray"
                    v-on:click="removeMember(resource.cardMembersId)"
                  >
                    <v-icon>remove_circle</v-icon>
                  </v-btn>
                </div>
                <span :class="{ hidden: assignMembers.length > 0  }">There are no assignaments</span>

                <div class="ua-addnew">
                  <v-autocomplete
                    v-model="newMemberId"
                    :items="searchMembers"
                    :loading="isLoadingMembers"
                    :search-input.sync="searchMember"
                    item-text="name"
                    item-value="memberId"
                    :label="$t('message.Member')"
                    :no-data-text="$t('message.noMembersFound')"
                    :class="{ hidden: addNewMemberHidden}"
                  >
                    <v-btn
                      slot="prepend"
                      flat
                      icon
                      light
                      small
                      v-on:click="saveAssignedMembers"
                      v-bind:class="{ hidden: newMemberId <= 0 }"
                    >
                      <v-icon>done</v-icon>
                    </v-btn>
                  </v-autocomplete>
                </div>
              </div>

              <v-text-field v-model="effort" :label="$t('message.Effort')" suffix="h"></v-text-field>

              <v-select
                :items="statuses"
                v-model="statusId"
                item-text="name"
                item-value="statusId"
                @change="statusChanged($event)"
                :label="$t('message.Status')"
              ></v-select>

              <v-autocomplete
                v-model="projectId"
                :items="projects"
                :loading="isLoadingProjects"
                :search-input.sync="searchProject"
                item-text="name"
                item-value="projectId"
                :label="$t('message.Project')"
                :no-data-text="$t('message.ajaxAutoComplete')"
              ></v-autocomplete>

              <v-select
                :items="cardTypes"
                v-model="cardTypeId"
                item-text="name"
                item-value="cardTypeId"
                :label="$t('message.CardType')"
              ></v-select>

              <v-menu
                ref="menuStart"
                :close-on-content-click="false"
                v-model="menuStart"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="startDate"
                  :label="$t('message.StartDate')"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="startDate" no-title scrollable @input="menuStart = false"></v-date-picker>
              </v-menu>
              <v-menu
                ref="menu"
                :close-on-content-click="false"
                v-model="dueMenu"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="dueDate"
                  :label="$t('message.DueDate')"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="dueDate" no-title scrollable @input="dueMenu = false"></v-date-picker>
              </v-menu>
              <v-tooltip left>
                <div slot="activator">
                  <v-btn flat icon dark>
                    <img
                      v-bind:src="ownerImage"
                      alt="owner image"
                      style="width:28px; border-radius: 50%;"
                    />
                  </v-btn>
                  <span>{{ ownerName }}</span>
                </div>
                <span>{{ $t("message.CardOwner")}}</span>
              </v-tooltip>
            </div>
          </div>
        </v-tab-item>
        <v-tab-item>
          <card-time-listing ref="cardTimeListing" :listingLink="cardTimeLink" @timechanged="load"></card-time-listing>
        </v-tab-item>
      </v-tabs>
    </div>
    <v-snackbar v-model="showmessage" bottom="bottom" right="right" :timeout="6000">
      <span>{{ alertMessage }}</span>
      <v-btn v-on:click="showmessage = false" flat icon dark>
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import GenericRepository from "../../services/GenericRepository.js";
import CardRepository from "../../services/CardRepository.js";
import CardTimeListing from "./CardTimeListing.vue";
import ProjectRepository from "../../services/ProjectRepository.js";
import HAL from "../../helpers/HAL.js";
import { mapGetters } from "vuex";

export default {
  name: "CardPage",
  computed: {
    ...mapGetters(["user"]),
    computedPageHeight: function() {
      return this.pageHeight + "px";
    },
    cardIdFormat: function() {
      if (this.cardId) return "#" + this.cardId;

      return "";
    },
    cardProgress: function() {
      let totalSpent = this.overallSpent + parseFloat(this.timeSpent, 10);
      let overral = totalSpent + parseFloat(this.timeRemaining, 10);

      let result = (totalSpent / overral) * 100;
      if (isNaN(result)) return 0;
      return Math.round(result);
    }
  },
  components: {
    CardTimeListing
  },
  data() {
    return {
      pageHeight: 10,
      entityName: "",
      entityDescription: "",
      cardId: null,
      updateLink: null,
      updateStatusLink: null,
      cardStatusLink: null,
      insertLink: "/api/cards",
      backLink: "/card-list",
      statusId: null,
      cardTypeId: null,
      projectId: null,
      sprintId: null,
      iterationId: null,
      featureId: null,
      parentId: null,
      startDate: null,
      dueDate: null,
      effort: 0,
      projects: [],
      isLoadingProjects: false,
      searchProject: null,
      cardTypes: [],
      statuses: [],
      menuStart: false,
      dueMenu: false,
      ownerImage: "",
      ownerName: "",
      showmessage: false,
      alertMessage: "",
      isLoadingMembers: false,
      searchMember: null,
      searchMembers: [],
      newMemberId: null,
      addNewMemberHidden: true,
      assignMembers: [],
      timeDate: null,
      menuTimeDate: false,
      addTimeLink: null,
      timeRemaining: 0,
      timeSpent: 0,
      timeComment: "",
      timeMenu: false,
      cardTimeLink: "",
      overallSpent: 0,
      disableTimeSpentWatch: false
    };
  },
  methods: {
    removeMember(event) {
      CardRepository.removeMember(this.cardId, event).then(response => {
        if (response.data.status == "Success") {
          this.loadAssignedMembers();
          this.$emit("save");
        }
      });
    },
    goBack() {
      this.$emit("back");
    },
    statusChanged(event) {
      if (!this.updateStatusLink || !this.cardId) return;

      GenericRepository.update(this.updateStatusLink.href, {
        statusId: event
      }).then(response => {
        if (response.data && response.data.status == "Success") {
          this.statuses = HAL.getEmbededResources(response.data, "help:status");
          this.$emit("save");
        }
      });
    },
    toggleAddNewMember() {
      if (this.addNewMemberHidden) {
        this.isLoadingMembers = true;
        GenericRepository.getCollection(
          "/api/projects/" + this.projectId + "/members/0/25"
        )
          .then(response => {
            if (response.data.status == "Success") {
              let items = HAL.getEmbededResources(
                response.data,
                "help:project-member"
              );
              this.searchMembers = [];
              for (let i in items) {
                items[i].name = items[i].firstName + " " + items[i].lastName;
                this.searchMembers.push(items[i]);
              }
            }
          })
          .finally(() => (this.isLoadingMembers = false));
      } else {
        this.searchMembers = [];
        this.newMemberId = null;
      }
      this.addNewMemberHidden = !this.addNewMemberHidden;
    },
    loadAssignedMembers() {
      GenericRepository.getCollection(
        "/api/cards/" + this.cardId + "/members/0/25"
      ).then(response => {
        if (response.data.status == "Success") {
          let items = HAL.getEmbededResources(
            response.data,
            "help:card-members-assign"
          );
          this.assignMembers = [];
          for (let i in items) {
            items[i].name = items[i].firstName + " " + items[i].lastName;
            this.assignMembers.push(items[i]);
          }
        }
      });
    },
    saveAssignedMembers() {
      let crtDate = {
        memberId: this.newMemberId
      };
      CardRepository.assignMember(this.cardId, crtDate).then(response => {
        if (response.data.status == "Success") {
          this.loadAssignedMembers();
          this.$emit("save");
        }
      });
      this.addNewMemberHidden = true;
      this.searchMembers = [];
      this.newMemberId = null;
    },
    saveTime() {
      if (this.addTimeLink) {
        let postData = {
          spent: this.timeSpent,
          remaining: this.timeRemaining,
          comment: this.timeComment,
          date: this.timeDate,
          memberId: this.user.memberId,
          cardId: this.cardId
        };

        GenericRepository.insert(this.addTimeLink.href, postData).then(
          response => {
            if (response.data.status == "Success") {
              this.alertMessage = this.$t("message.SuccessfullySaved");
              this.showmessage = true;
              this.timeMenu = false;
              this.overallSpent += parseFloat(this.timeSpent);
              this.disableTimeSpentWatch = true;
              this.timeSpent = 0;
              this.timeComment = "";
              this.timeDate = this.$moment().format("YYYY-MM-DD");
              this.$refs.cardTimeListing.load();
            } else {
              this.alertMessage = response.data.message;
              this.showmessage = true;
            }
          }
        );
      }
    },
    save() {
      var entity = {
        cardId: this.cardId,
        description: this.entityDescription,
        name: this.entityName,
        statusId: this.statusId,
        cardTypeId: this.cardTypeId,
        projectId: this.projectId,
        sprintId: this.sprintId,
        iterationId: this.iterationId,
        featureId: this.featureId,
        parentId: this.parentId,
        startDate: this.startDate,
        dueDate: this.dueDate,
        effort: this.effort
      };
      if (entity.cardId > 0) {
        GenericRepository.update(this.updateLink.href, entity).then(
          function(response) {
            if (response.data && response.data.status == "Success") {
              this.timeRemaining = response.data.remaining;
              this.alertMessage = this.$t("message.SuccessfullySaved");
              this.showmessage = true;
              this.$emit("save");
            } else {
              this.alertMessage = response.data.message;
              this.showmessage = true;
            }
          }.bind(this)
        );
      } else {
        GenericRepository.insert(this.insertLink, entity)
          .then(
            function(response) {
              if (response.data && response.data.status == "Success") {
                this.cardId = response.data.cardId;
                this.updateLink = HAL.getLink(
                  response.data,
                  "help:card-update"
                );
                this.updateStatusLink = HAL.getLink(
                  response.data,
                  "help:card-status-update"
                );
                this.cardStatusLink = HAL.getLink(
                  response.data,
                  "help:card-statuses"
                );
                let link = this.backLink + "/" + response.data.cardId;
                window.vm.$router.push(link);
                this.alertMessage = this.$t("message.SuccessfullySaved");
                this.showmessage = true;
                this.$emit("save");
              } else {
                this.alertMessage = response.data.message;
                this.showmessage = true;
              }
            }.bind(this)
          )
          .finally(() => {
            if (!this.cardStatusLink) return;
            GenericRepository.getCollection(this.cardStatusLink.href).then(
              response => {
                if (response.data && response.data.status == "Success") {
                  this.statuses = HAL.getEmbededResources(
                    response.data,
                    "help:status"
                  );
                }
              }
            );
          });
      }
    },
    load() {
      CardRepository.getByID(this.$route.params.cid).then(
        function(response) {
          if (response.data && response.data.status == "Success") {
            this.entityName = response.data.name;
            this.entityDescription = response.data.description;
            this.cardId = response.data.cardId;
            this.statusId = response.data.statusId;
            this.cardTypeId = response.data.cardTypeId;
            this.projectId = response.data.projectId;
            this.sprintId = response.data.sprintId;
            this.iterationId = response.data.iterationId;
            this.featureId = response.data.featureId;
            this.parentId = response.data.parentId;
            this.effort = response.data.effort;
            this.timeRemaining = response.data.remaining;
            this.overallSpent = response.data.spent;

            if (response.data.startDate)
              this.startDate = this.$moment(response.data.startDate).format(
                "YYYY-MM-DD"
              );
            if (response.data.dueDate)
              this.dueDate = this.$moment(response.data.dueDate).format(
                "YYYY-MM-DD"
              );

            if (response.data.owner) {
              this.ownerName = response.data.owner.name;
              this.ownerImage = response.data.owner.image;
            }

            if (response.data.project) {
              this.projects = [
                {
                  projectId: response.data.project.id,
                  name: response.data.project.name
                }
              ];
            }
            this.updateLink = HAL.getLink(response.data, "help:card-update");
            this.updateStatusLink = HAL.getLink(
              response.data,
              "help:card-status-update"
            );
            this.cardStatusLink = HAL.getLink(
              response.data,
              "help:card-statuses"
            );
            this.addTimeLink = HAL.getLink(response.data, "help:card-time-add");
            let timeHalLink = HAL.getLink(response.data, "help:card-time-list");
            this.cardTimeLink = timeHalLink ? timeHalLink.href : "";
            this.loadAssignedMembers();
          }
        }.bind(this)
      );
    }
  },
  created() {
    this.pageHeight = window.innerHeight - 57 - 25 - 25;
    GenericRepository.getCollection("/api/cardtypes").then(response => {
      if (response.data && response.data.status == "Success") {
        this.cardTypes = HAL.getEmbededResources(
          response.data,
          "help:cardtype"
        );
      }
    });

    var cId = !isNaN(this.$route.params.cid) ? this.$route.params.cid : 0;
    GenericRepository.getCollection("/api/cards/" + cId + "/statuses").then(
      response => {
        if (response.data && response.data.status == "Success") {
          this.statuses = HAL.getEmbededResources(response.data, "help:status");
        }
      }
    );
    this.ownerName = this.user.firstName + " " + this.user.lastName;
    this.ownerImage = this.user.image;
    var segments = this.$route.path.split("/");
    if (segments.length > 1) {
      this.backLink =
        segments[1] == "card-list"
          ? "/" + segments[1]
          : "/" + segments[1] + "/" + segments[2] + "/" + segments[3];
    }
    if (!isNaN(this.$route.params.cid)) {
      this.load();
    }
  },
  watch: {
    timeSpent(value, oldValue) {
      if (this.disableTimeSpentWatch) {
        this.disableTimeSpentWatch = false;
        return;
      }

      let diff = value - oldValue;
      this.timeRemaining -= diff;
    },
    searchProject(value) {
      if (!value || value.length < 3) return;

      if (this.isLoadingProjects) return;

      this.isLoadingProjects = true;

      ProjectRepository.search(value)
        .then(response => {
          this.projects = HAL.getEmbededResources(
            response.data,
            "help:project"
          );
        })
        .finally(() => (this.isLoadingProjects = false));
    }
  }
};
</script>

<style lang="stylus">
@import '../../assets/css/tool-bar.css';
@import '../../assets/css/entity-page.css';
</style>

<style scoped>
.ua-addnew {
  height: 60px;
  margin-top: 5px;
}

.user-assignaments {
  min-height: 100px;
}

.ua-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.user-assignaments span.ua-title {
  font-size: 20px;
}
.card-progress {
  position: absolute;
  top: 20px;
  right: 24px;
}

.time-form {
  padding: 10px;
}

.time-form > div {
  display: flex;
  flex-direction: row;
}

.time-form > div > .v-text-field:last-child {
  margin-left: 10px;
}
</style>
